import {
  List,
  NumberField,
  DatagridConfigurable,
  TextField,
  SelectField,
  NumberInput,
  SelectArrayInput,
  TextInput,
} from 'react-admin';
import { ReactElement } from 'react';
import { SCAN_STATUS_CHOICES } from './utils';
import { ScanResource } from '../../Entities/Scan';
import { DEFAULT_LIST_PAGE_PAGINATION_LIMIT } from '../../utils';
import TzDateTimeInput from '../../Components/TzDate/TzDateTimeInput';
import ExtendedListActions from '../../Components/ExtendedListActions';
import ScanButton from '../../Components/ScanButton/ScanButton';
import TzDateField from '../../Components/TzDate/TzDateField';

const filters = (): ReactElement[] =>
  [
    <NumberInput alwaysOn key="filter.id" label="ID" source="equals.id" />,
    <SelectArrayInput
      alwaysOn
      choices={SCAN_STATUS_CHOICES}
      key="filter.status"
      label="Status"
      source="any.status"
    />,
    <TextInput
      alwaysOn
      key="filter.initiated_by"
      label="Initiated By"
      source="contains.initiated_by"
    />,
    <TzDateTimeInput key="start_date_before" label="Starts Before" source="lessThan.start_date" />,
    <TzDateTimeInput key="start_date_after" label="Starts After" source="greaterThan.start_date" />,
    <TzDateTimeInput key="end_date_before" label="Ends Before" source="lessThan.end_date" />,
    <TzDateTimeInput key="end_date_after" label="Ends After" source="greaterThan.end_date" />,
  ].filter((value) => typeof value !== 'boolean');

export default function ScansList(): ReactElement {
  return (
    <List<ScanResource>
      perPage={DEFAULT_LIST_PAGE_PAGINATION_LIMIT}
      sort={{ order: 'DESC', field: 'id' }}
      filters={filters()}
      actions={
        <ExtendedListActions
          hasFilters={filters().length > 0}
          hasCreate={false}
          customActions={[<ScanButton label="Scan All" key="run" size="small" />]}
        />
      }
    >
      <DatagridConfigurable bulkActionButtons={false} rowClick="show">
        <TextField source="id" label="ID" />
        <SelectField source="attributes.status" label="Status" choices={SCAN_STATUS_CHOICES} />
        <TzDateField source="attributes.start_date" label="Start Date" showTime />
        <TzDateField source="attributes.end_date" label="End Date" showTime />
        <TextField source="attributes.initiated_by" label="Initiated By" />
        <NumberField source="attributes.total_shops" label="Total Shops" />
        <NumberField source="attributes.successful_shops" label="Successful Shops" />
        <NumberField source="attributes.minor_issue_shops" label="Minor Issues" />
        <NumberField source="attributes.major_issue_shops" label="Major Issues" />
        <NumberField source="attributes.unsuccessful_shops" label="Unsuccessful Shops" />
      </DatagridConfigurable>
    </List>
  );
}
